import { MyCheckbox } from "components";
import { TextareaField } from "components/textareaField";
import { formatDate } from "helper/dateFormat";
import { getCurrency, numberFormat } from "helper/numberFormat";
import React from "react";
import thousands from "thousands";
import { CheckFloatValue } from "../../../utils/functions";
const Review = ({ calculateConvenienceFeeAmount,...props }) => {
  const formik = props;
  const currency = getCurrency();
  const sumOfDiscounts = formik?.values?.allData?.reduce((a, b) => {
    if (b.discount_type === "%" && b.discount) {
      return a + (b?.charge?.amount * b.discount) / 100;
    }
    if (b.discount_type === "$" && b.discount) {
      return a + b.discount;
    } else {
      return 0;
    }
  }, 0);
  const sumOfAmounts = formik.values?.allData?.reduce((a, b) => {
    return a + parseFloat(b?.charge?.amount);
  }, 0);
  const acutalTotal = parseFloat(formik?.values?.actual_total);

  const currentTotal = parseFloat(formik?.values?.current_total);

  const splittedAmount = parseFloat(formik?.values?.split_amount);

  const splitAmount = parseFloat(formik?.values?.values?.[0].split_amount);

  const sumAmounts = parseFloat(sumOfAmounts);

  const TotalSum = sumAmounts;
  const currentAmount = parseFloat(formik?.values?.current_amount);

  // const sumOfTaxes = formik?.values?.allData?.reduce((a, b) => {
  //   if (b.tax_type === "%" && b.tax_deductible) {
  //     return a + (b?.charge?.amount * b.tax_deductible) / 100;
  //   }
  //   if (b.tax_type === "$" && b.tax_deductible) {
  //     return a + b.tax_deductible;
  //   } else {
  //     return 0;
  //   }
  // }, 0);

  const sumOfTotalAmounts = TotalSum - sumOfDiscounts;
  // ?.toString()
  // .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const methods = Object.entries(formik?.values)
    .filter(([key]) => key.includes("_payment"))
    .map(([key, value]) => {
      const split = key.split("_payment");
      if (split[0] === "check" && !value.check_number) {
        return undefined;
      }
      if (split[0].includes("credit")) {
        return {
          ...value,
          paymentMethod: split[0],
          amount: isNaN(formik?.values?.creditCardAmount)
          ? "0" 
          : formik?.values?.creditCardAmount,
          last4: formik?.values?.last4 /* cvc: values.cvc */,
        };
      }
      if (split[0].includes("ach")) {
        return {
          ...value,
          paymentMethod: split[0].toUpperCase(),
          amount: isNaN(formik?.values?.ach) ? "0" : formik?.values?.ach,
          achId: formik?.values?.payments[0]?.ACH /* cvc: values.cvc */,
        };
      }
      if (split[0].includes("cash")) {
        return {
          ...value,
          paymentMethod: split[0] === "cash" ? "Cash" : "",
          amount: isNaN(formik?.values?.cash_payment)
          ? "0"
          : formik?.values?.cash_payment,
        };
      }
      if (split[0].includes("onAccountCredit")) {
        return {
          ...value,
          paymentMethod:
            split[0] === "onAccountCredit" ? "Credit On Account" : "",
          amount: isNaN(formik?.values?.onAccountCredit_payment)
          ? "0"
          : formik?.values?.onAccountCredit_payment,
        };
      }
      return {
        paymentMethod: split[0],
        amount: formik?.values?.[key],
      };
    })
    .filter((item) => item !== undefined);


  const totalSplittedAmount =
    formik?.values?.allData &&
    formik?.values?.allData?.map((item) => item?.charge?.amount);
  const sumOfSplittedAmount = totalSplittedAmount?.reduce(
    (partialSum, a) => partialSum + a,
    0
  );

  const totalAllDataDueAmount =
  formik?.values?.allData?.length > 0 &&
  formik?.values?.allData?.reduce(
    (accumulator, obj) => accumulator + obj.Charges?.amount_due,
    0
  );

  const sumOfMethods = methods?.reduce((sum, a) => sum + Number(a.amount), 0);
  const sumOfChecks =
    formik?.values?.checks?.length > 0
      ? formik?.values?.checks?.reduce((sum, a) => sum + Number(a?.amount), 0)
      : 0;

  const totalSumofValues = Number(sumOfMethods) + Number(sumOfChecks);

  const paidAmount = formik.values?.values?.[0]?.isRecurring
  ? +formik.values?.actual_total
  : totalSumofValues;


  const totalAmount =
  (formik.values?.type === "edit-charge" && formik.values?.values?.[0]?.charge?.paid) 
  ? (+formik.values?.actual_total - +formik.values?.values?.[0]?.charge?.paid)
  : formik.values.allData?.length > 0
  ? +totalAllDataDueAmount
  : formik.values?.values?.[0]?.charge?.paid === 0
  ? +formik.values?.actual_total
  : formik.values?.values?.[0]?.charge?.paid
  ? 
      (+formik.values?.values?.[0]?.is_splitted === false
        ? formik.values?.actual_total
        : Number(formik.values?.values?.[0]?.total_amount) -
          formik.values?.values?.[0]?.charge?.paid
      )
  : formik.values?.type === "edit-charge"
  ? +formik.values?.actual_total
  : formik.values?.amount_due === 0 || formik.values?.amount_due
  ? +formik.values?.amount_due
  : formik?.values?.allData?.[0]?.charge?.amount
  ? +sumOfSplittedAmount
  : formik?.values?.values?.[0]?.split_amount
  ? +formik?.values?.values?.[0]?.split_amount
  : formik?.values?.actual_total
  ? +formik.values?.actual_total
  : formik.values?.current_total
  ? +formik.values?.current_total
  : formik.values?.current_amount
  ? +formik.values?.current_amount
  : formik.values?.values?.[0]?.split_amount
  ? +formik.values?.values?.[0]?.split_amount
  : +formik.values?.values?.[0]?.total_amount ??
    +sumOfAmounts;



  const calculatedTotalAmount = numberFormat({number:(+totalAmount + +calculateConvenienceFeeAmount(formik?.values)), decimal: 2, style: "decimal"});

  

  const calculateMethodWithConvenienceFee = (method) => {
    let total = 0;
    const paymentMethod = formik?.values?.allPaymentsMethods?.find(item => item?.type?.toLowerCase() === method?.paymentMethod?.toLowerCase())
    if(paymentMethod?.coverConvenienceFee) {
      const cvAmount = paymentMethod?.convenienceFeeInfo?.type === "%" ? (method?.amount * paymentMethod?.convenienceFeeInfo?.amount) / 100 : +paymentMethod?.convenienceFeeInfo?.amount;
      total = +cvAmount + +method?.amount;
    } else {
      total = method?.amount;
    }

    return numberFormat({number:total, decimal: 2, style: "currency"});
  }

  const displayInstallmentMethod = (method,amount) => {
    const cycles = formik?.values?.installmentDetails?.cycle?.value;
    const amountOfEach = +amount / cycles;
    const formatAmount = numberFormat({number:amountOfEach, decimal: 2, style: "currency"});
    const startInstallment = formatDate({date:formik?.values?.installmentDetails?.startInstallment, formatType: "defaultWithUTC"});

    const valid = method?.toLowerCase() === "credit card" && formik?.values?.allowInstallment;
    return valid ? `(In ${cycles} monthly installments of ${formatAmount} each, starting on ${startInstallment}) ` : "";
}




  return (
    <div className="review">
      <div className="review-row">
        <div>Amount</div>
        <div>
          {formik.values?.amount_due === 0 || formik.values?.amount_due
            ? numberFormat({number:(formik.values?.amount_due), decimal: 2, style: "currency"})
            : formik?.values?.allData?.[0]?.charge?.amount
            ? numberFormat({number:(sumOfSplittedAmount), decimal: 2, style: "currency"})
            : formik?.values?.values?.[0]?.split_amount
            ? numberFormat({number:(
                formik?.values?.values?.[0]?.split_amount
              ), decimal: 2, style: "currency"})
            : formik.values?.current_total
            ? numberFormat({number:(formik.values?.current_total), decimal: 2, style: "currency"})
            : formik?.values?.values?.[0].is_splitted === false
            ? numberFormat({number:(acutalTotal ? acutalTotal : TotalSum), decimal: 2, style: "currency"})
            : splittedAmount && splitAmount
            ? numberFormat({number:(splittedAmount ? splittedAmount : TotalSum), decimal: 2, style: "currency"})
            : splitAmount
            ? numberFormat({number:(splitAmount ? splitAmount : TotalSum), decimal: 2, style: "currency"})
            : splittedAmount
            ? numberFormat({number:(splittedAmount ? splittedAmount : TotalSum),  decimal: 2, style: "currency"})
            : numberFormat({number:(currentTotal ?? TotalSum), decimal: 2, style: "currency"})}
        </div>
      </div>
      <div className="review-row mt-3">
        <div>Discount</div>
        <div>
          {formik?.values?.values?.[0]?.discount_type === "$" ? currency : ""}
          {formik?.values?.values?.[0]?.discount
            ? numberFormat({number:+formik?.values?.values?.[0]?.discount, decimal: 2, style: "decimal"})
            : sumOfDiscounts
            ? numberFormat({number:+sumOfDiscounts, decimal: 2, style: "decimal"})
            : "0.00"}
          {formik?.values?.values?.[0]?.discount_type === "%" ? "%" : ""}
        </div>
      </div>
      <div className="review-row mt-3">
        <div>Convenience Fee</div>
        <div>
          {/* {numberFormat({number:formik?.values?.convenient_fee, decimal: 2, style: "currency"})} */}
          {numberFormat({number:calculateConvenienceFeeAmount(formik?.values), decimal: 2, style: "currency"})}
        </div>
      </div>
      <hr className="hr-div" />
      <div className="review-row mt-3">
        <div className="subtotal">Paid</div>
        <div className="subtotal">{numberFormat({number:paidAmount, decimal: 2, style: "currency"})}</div>
      </div>
      <div className="review-row mt-6">
        <div>Total</div>
        <div>{currency}{calculatedTotalAmount}</div>
      </div>
      <hr className="hr-div" />
      <div className="review-row mt-3">
        <div className="subtotal">Remaining balance</div>
        <div className="subtotal">
          {currency}
          {formik.values?.allData?.length > 0
            ? thousands(
                (totalAllDataDueAmount - totalSumofValues).toFixed(2) ===
                  "-0.00"
                  ? "0.00"
                  : (totalAllDataDueAmount - totalSumofValues).toFixed(2)
              )
            : formik.values?.values?.[0]?.charge?.paid === 0
            ? numberFormat({number:
                (+formik.values?.actual_total - totalSumofValues), decimal: 2, style: "decimal"})
            : formik.values?.values?.[0]?.charge?.paid
            ? numberFormat({number:(+totalAmount - +paidAmount), decimal: 2, style: "decimal"})
            : formik.values?.values?.[0]?.isRecurring
            ? numberFormat({number:
                (
                  formik.values?.actual_total - formik.values?.actual_total
                ), decimal: 2, style: "decimal"}
              )
            : formik.values?.type === "edit-charge"
            ? numberFormat({number:
                (
                  formik.values?.actual_total - (totalSumofValues ?? 0.0)
                ), decimal: 2, style: "decimal"}
              )
            : numberFormat({number:
                (formik?.values?.amount_due
                  ? formik?.values?.amount_due
                  : formik?.values?.actual_total - (totalSumofValues ?? 0.0)
                ), decimal: 2, style: "decimal"}
              ) ?? "0.00"}
        </div>
      </div>
      <div className="second-pr">
        <div className="mb-5">Payment Method</div>
        {methods?.map((item) => 
          !!item?.amount && item?.amount !== "" && (
            <div className="review-row" key={item.paymentMethod}>
              <div className="">
                <span>
                  {item?.paymentMethod && item.amount ? item?.paymentMethod : ""}{" "}
                  {item?.last4 ?? " "}
                </span>
                {displayInstallmentMethod(item?.paymentMethod,item?.amount)}
              </div>
              <div className="">{calculateMethodWithConvenienceFee(item)}</div>
            </div>
        ))}
        {formik?.values?.checks?.map((item) => (
          <div className="review-row" key={item.paymentMethod}>
            <div className="">
              {item?.paymentMethod} {item?.check_number ?? ""}
            </div>
            <div className="">{numberFormat({number:item?.amount, decimal: 2, style: "currency"})}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Review;

